import { NoAccess } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import type { IAuth } from "@/models/Auth";
import type { IGeneral } from "@/models/General";

export type IPermissionCode =
  | "PRT_PRO_MAIN"
  | "PRT_PRO_VIEW_ADMIN"
  | "PRT_PRO_MAIN_EDIT"
  | "PRT_SUPP_ADD"
  | "PRT_SUPP_MAIN"
  | "PRT_SUPP_MARKETING"
  | "PRT_SUPP_USER_LIST"
  | "PRT_SUPP_BUSINESS_LIST"
  | "PRT_SUPP_BUSINESS_EDIT"
  | "PRT_BUYER_ADD"
  | "PRT_BUYER_MAIN"
  | "PRT_BUYER_MARKETING"
  | "PRT_BUYER_USER_LIST"
  | "PRT_BUYER_BUSINESS_LIST"
  | "PRT_BUYER_BUSINESS_EDIT"
  | "PRT_BRNCH_ADD"
  | "PRT_BRNCH_MAIN"
  | "PRT_BRNCH_ADDR"
  | "PRT_BRNCH_EDIT"
  | "PRT_BRNCH_LIST"
  | "PRT_WRH_ADD"
  | "PRT_WRH_MAIN"
  | "PRT_WRH_ADDR"
  | "PRT_WRH_EDIT"
  | "PRT_WRH_LIST"
  | "PRT_SUPP_BUSINESS_DETAIL"
  | "PRT_SUPP_BUSINESS_CHANGE_STATUS"
  | "PRT_BUYER_BUSINESS_DETAIL"
  | "PRT_BUYER_BUSINESS_CHANGE_STATUS"
  | "PRT_BRNCH_DETAIL"
  | "PRT_WRH_DETAIL"
  | "PRT_WRH_STAFF_LIST"
  | "PRT_WRH_STAFF_ADD_KEEPER"
  | "PRT_WRH_STAFF_ADD_SUB"
  | "PRT_WRH_STAFF_EDIT"
  | "PRT_WRH_STAFF_REMOVE"
  | "PRT_WRH_STAFF_MANAGE_FLAG"
  | "PRT_WRH_STAFF_BULK";

export function usePermission(code: IPermissionCode) {
  const { t } = useTranslation("common");
  const user = useSelector((state: { auth: IAuth }) => state.auth.user);
  const permissions = useSelector((state: { general: IGeneral }) => state.general.permissions);

  function accessDenied() {
    return (
      <NoAccess title={t("accessDenied")} permission={code} />
    );
  }

  const text = permissions?.find((item) => item.code === code)?.name ?? t("accessDenied");
  const hasAccess = (user?.permissions ?? []).some((som) => som.code === code) || false;

  return {
    text,
    hasAccess,
    accessDenied,
  };
}
